import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutContainerComponent } from './layout/layout-container/layout-container.component';
import { UserResolver } from './shared/services/user-resolver.service';
import { authGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./public/public.module').then(m => m.PublicModule),
  },
  {
    path: '',
    component: LayoutContainerComponent,
    canActivate: [authGuard],
    resolve: { user: UserResolver },
    children: [
      {
        path: 'gst-reconciliation',
        loadChildren: () => import('./matching/matching.module').then((m) => m.MatchingModule),
      },
      {
        path: 'import-matching',
        loadChildren: () => import('./import-matching/import-matching.module').then((m) => m.ImportMatchingModule),
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
      },
      {
        path: 'home',
        loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'profile',
        loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
      },
    ],
  },

  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'subscription',
    resolve: { user: UserResolver },
    loadChildren: () => import('./subscription/subscription.module').then((m) => m.SubscriptionModule),
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
 
  
  {
    path: '**',
    redirectTo: 'auth',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
